module.exports = __webpack_public_path__ + "img/maleki.57c1f1c1.jpg";